// @flow
import JQueryView, { on } from '../../common/JQueryView';

// app/javascript/application/views/company/stock_options/forms/TermAndConditionsView.js を参考にしてます
export default class StockOptionConfirm extends JQueryView {
  backPath: string;

  constructor(backPath: string) {
    super('.simple_form');
    this.backPath = backPath;
  }

  // 戻るボタンを押下した場合はconfirmに再度送信する
  @on({ event: 'submit' })
  onClickSubmit(event: any) {
    event.preventDefault(); // Prevent the form from submitting

    if (event.originalEvent.submitter.id == 'submit-button') {
      this.$el[0].action = this.backPath;
    }

    this.$el[0].submit(); // Submit the form
  }

  // 閉じるボタン
  @on({ event: 'click', selector: 'a.close' })
  onClickClose() {
    close();
  }
}
